import { logEvent } from '../../lib/analytics';
import { redirectToOnboardingCheckout } from '../../lib/redirect';
import { useVoiceDemo } from '../../providers/VoiceDemoContext';
import { DownloadIcon } from '../icons/Download';

export const DownloadAudio = () => {
  const { currentVoice, currentContent } = useVoiceDemo();
  return (
    <button
      onClick={(event) => {
        event.preventDefault();
        logEvent('download_interaction', {
          action: 'clicked',
        });
        void redirectToOnboardingCheckout({
          voiceId: currentVoice.id,
          textContent: currentContent,
        });
      }}
      className="flex h-12 items-center justify-center gap-2 rounded-[16px] border-[1px] border-[#E9EAF0] px-4 py-3 hover:bg-[#E9EAF0] cursor-pointer">
      
        <DownloadIcon />
      <div className="hidden @sm:block">Download</div>
    </button>
  );
};
